@for (suggestion of suggestions(); track suggestion) {
	<button
		ada-type="small"
		class="ada-prompt-suggestion ada-border ada-text-align-left ada-full-width"
		[class.ada-is-disabled]="isDisabled()"
		(click)="!isDisabled() && selected.emit(suggestion)"
	>
		<ada-icon icon="faArrowTurnDownRight" />
		&nbsp;{{ suggestion }}
	</button>
}
